export const getBaseUrl = (channelId: string) => {
  switch (channelId) {
    case '1':
      return import.meta.env.VITE_BASE_URL_CHANNEL_1
    case '2':
      return import.meta.env.VITE_BASE_URL_CHANNEL_2
    case '4':
      return import.meta.env.VITE_BASE_URL_CHANNEL_4
    case '7':
      return import.meta.env.VITE_BASE_URL_CHANNEL_7
    case '8':
      return import.meta.env.VITE_BASE_URL_CHANNEL_8
    case '9':
      return import.meta.env.VITE_BASE_URL_CHANNEL_9
    default:
      throw new Error(`No base url set up for this channel ${channelId}`)
  }
}